import { FC, ReactElement } from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import { BUTTON_VARIANTS, ISectionWrapperProps as Props } from './types';
import { Button } from '../Button/Button';
import { ContentWrapper } from '../ContentWrapper/ContentWrapper';

import styles from './SectionWrapper.module.scss';

export const SectionWrapper: FC<Props> = ({
  sectionTitle,
  children,
  buttonText = '',
  className = '',
  buttonClickHandler = () => {},
  buttonVariant = BUTTON_VARIANTS.DEFAULT,
  ...buttonProps
}): ReactElement => {
  return (
    <ContentWrapper isSection className={clsx(styles.sectionWrapper, className)}>
      <Box className={styles.sectionTitleWrapper}>
        <Typography variant="h5">{sectionTitle}</Typography>
        {buttonText && (
          <Button
            variant="text"
            className={clsx(styles.button, buttonVariant === BUTTON_VARIANTS.RED && styles.redButton)}
            onClick={buttonClickHandler}
            {...buttonProps}
          >
            {buttonText}
          </Button>
        )}
      </Box>
      {children}
    </ContentWrapper>
  );
};
